export const STEPPER_CONFIG = {
  displayColumns: 6,
  footerTitle: 'Total',
};
